<template>
	<div class="container">
		<div class="footer__disclaimers body-xs muted pt-150 pb-150 bt">
			<RichTextComponent :blocks="disclaimer" />
			<p v-if="isOsanoAvailable">
				If you are interested, <CookiePreferencesLink>click here</CookiePreferencesLink> to manage your cookie
				preferences.
			</p>
			<p> Copyright &copy; {{ currentYear }} {{ fundName }} </p>
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import CookiePreferencesLink from '@components/layout/cookie-preferences-link.vue';
import RichTextComponent from '@components/sanity/rich-text-component.vue';
import { useConsentStore } from '@stores/consent';
import { SanityRichTextBlock } from 'types/sanity';

interface Props {
	disclaimer: Array<SanityRichTextBlock>;
	fundName: string;
}

defineProps<Props>();

const consentStore = useConsentStore();
const isOsanoAvailable = computed((): boolean => consentStore.isOsanoAvailable);

const currentYear = computed((): number => {
	const today = new Date();
	return today.getFullYear();
});
</script>
